import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import type { Resource } from "i18next";
import English from "./resources/en.json";
import Italian from "./resources/it.json";
import appStatusStore from "shared/store/appStatusStore";

const resources: Resource = {
  en: { translation: English },
  it: { translation: Italian },
};

i18n.use(initReactI18next).init({
  debug: false,
  lng: appStatusStore.getState().language,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
  resources,
});

//** in case we change language runtime */
appStatusStore.subscribe((state) => {
  i18n.changeLanguage(state.language);
});

export default i18n;
